import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import Summary from './components/Summary'
import Table from './components/Table'

import hocConnect from './hocConnect'
import './style.scss'

@hocBlock(config.modules.report.key, { levelReload: true })
@hocConnect
export default class Contracts extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        contractsTableChange: PropTypes.func.isRequired,
        customData: PropTypes.object,
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        level: PropTypes.string,
        locale: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
    }

    handleTableChange = (changeData) => {
        const { module, block, id, level, customData, contractsTableChange } = this.props

        contractsTableChange(module, block, id, level, customData, changeData)
    }

    render() {
        const { module, block, level, id, customData, data, locale } = this.props

        return (
            <div className={'contracts-block-container'}>
                <Summary entId={id} data={_.get(data, '[0]', {})} />
                <Table
                    module={module}
                    block={block}
                    level={level}
                    locale={locale}
                    entId={id}
                    customData={customData}
                    handleTableChange={this.handleTableChange}
                />
            </div>
        )
    }
}
